import React from "react";

const LINKS = [
    { label: "LinkedIn", href: "https://linkedin.com/in/manuel-repetschnig-0b354b328/" },
    { label: "itch.io",  href: "https://viegu.itch.io/" },
    { label: "Email",    href: "mailto:repetschnig.manuel@gmail.com" },
];

export const FooterComponent: React.FC = () => {
    return (
        <footer className="border-t border-rule bg-paper">
            <div className="page-container py-8 flex flex-col gap-4 sm:flex-row sm:items-baseline sm:justify-between">
                <p className="m-0 flex flex-wrap items-baseline gap-x-3">
                    <span className="font-display font-semibold text-ink">Manuel Repetschnig</span>
                    <span className="text-muted text-sm">The bugs in here are features (shh…)</span>
                </p>

                <div className="flex items-baseline gap-5 font-label">
                    {LINKS.map(link => (
                        <a
                            key={link.label}
                            href={link.href}
                            className="link"
                            {...(link.href.startsWith("http") ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                        >
                            {link.label}
                        </a>
                    ))}
                    <span className="label">© {new Date().getFullYear()}</span>
                </div>
            </div>
        </footer>
    );
};
